import script from "./gcdsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./gcdsComponent.vue?vue&type=script&setup=true&lang=js"

import "./gcdsComponent.vue?vue&type=style&index=0&id=703f5ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703f5ba0"]])

export default __exports__